import { watch } from 'vue'
import i18n from '../plugins/i18n'

export function useSeo() {
  let lastPageKey = null
  let lastVars = {}

  // === 1️⃣ SEO для статических страниц (через YAML / i18n config) ===
  function applySeoMeta(pageKey, vars = {}) {
    console.log('🧩 SEO apply for:', pageKey)

    const locale = i18n.global.locale.value
    const messages = i18n.global.messages.value
    const seo = messages?.[locale]?.seo_pages?.[pageKey]

    if (!seo) {
      console.warn(`⚠️ SEO config not found for page: ${pageKey}`)
      return
    }

    const title = replaceVars(seo.title, vars)
    const description = replaceVars(seo.description, vars)

    setHeadElements({
      title,
      description
    })

    // 💾 сохраняем страницу, чтобы при смене языка переустановить SEO
    lastPageKey = pageKey
    lastVars = vars
  }

  // === 2️⃣ SEO для динамических страниц (из API) ===
  function setDynamicSeo({ title, description, canonical, image } = {}) {
    console.log('🎯 Dynamic SEO set:', { title, description, canonical, image })

    setHeadElements({ title, description, canonical, image })
  }

  // === 3️⃣ Общая функция для установки тегов ===
  function setHeadElements({ title, description, canonical, image }) {
    try {
      // TITLE
      if (title && title.trim() !== '') {
        document.title = title
      }

      // DESCRIPTION
      if (description && description.trim() !== '') {
        updateMeta('description', description)
        updateMeta('og:description', description)
      }

      // CANONICAL
      if (canonical && canonical.trim() !== '') {
        updateCanonical(canonical)
        updateMeta('og:url', canonical)
      }

      // IMAGE
      if (image && image.trim() !== '') {
        updateMeta('og:image', image)
      }

      // OG TITLE
      if (title && title.trim() !== '') {
        updateMeta('og:title', title)
      }

      console.log(`✅ SEO обновлено: ${title || '(без заголовка)'}`)
    } catch (err) {
      console.error('❌ Ошибка при обновлении SEO:', err)
    }
  }

  /** Реакция на смену языка */
  watch(
    () => i18n.global.locale.value,
    (newLocale, oldLocale) => {
      if (lastPageKey) {
        console.log(`🌐 Locale changed from ${oldLocale} → ${newLocale}, reapplying SEO`)
        applySeoMeta(lastPageKey, lastVars)
      }
    }
  )

  /** Подстановки переменных вида {city}, {count} и т.д. */
  function replaceVars(template, vars) {
    if (!template) return ''
    return template.replace(/{(\w+)}/g, (_, key) => vars[key] || '')
  }

  /** Создание или обновление meta-тега */
  function updateMeta(name, content) {
    if (!content) return
    let tag =
      document.querySelector(`meta[name="${name}"]`) ||
      document.querySelector(`meta[property="${name}"]`)
    if (!tag) {
      tag = document.createElement('meta')
      if (name.startsWith('og:')) tag.setAttribute('property', name)
      else tag.setAttribute('name', name)
      document.head.appendChild(tag)
    }
    tag.setAttribute('content', content)
  }

  /** Добавление или обновление canonical */
  function updateCanonical(url) {
    if (!url) return
    let link = document.querySelector('link[rel="canonical"]')
    if (!link) {
      link = document.createElement('link')
      link.setAttribute('rel', 'canonical')
      document.head.appendChild(link)
    }
    link.setAttribute('href', url)
  }

  return {
    applySeoMeta, // для статических страниц (из YAML)
    setDynamicSeo // для данных из API (property, developer и др.)
  }
}
